import classNames from 'classnames';
import React from 'react';

import { Button } from '..';
import Modal from '../Modal';
import Content from './Content';

import * as style from './index.module.less';

/**
 * @typedef {{
 *   close: () => void,
 *   footer?: React.ReactNode,
 *   medias: import('modules/medias/types/abstract-media').AbstractMedia[],
 *   selectedMedia: import('modules/medias/types/abstract-media').AbstractMedia,
 *   selectMedia: (media: import('modules/medias/types/abstract-media').AbstractMedia) => void,
 * } & import('antd/lib/modal').ModalProps} MediaModalProps
 */
/** @type {React.FC<MediaModalProps>} */
const MediaModal = ({ close, medias, selectMedia, selectedMedia, footer = null, ...props }) => {
  const index = medias.findIndex(({ id }) => id === selectedMedia?.id);

  const onMediaPreviewedChange = React.useCallback(
    newIndex => {
      selectMedia(medias[newIndex]);
    },
    [medias, selectMedia]
  );

  if (!selectedMedia) {
    return null;
  }

  const handleClose = () => close(false);

  return (
    <Modal
      open
      centered
      destroyOnHidden
      footer={footer}
      onOk={handleClose}
      onCancel={handleClose}
      width="auto"
      className={classNames(style.container, style[selectedMedia.type], 'pb-0')}
      {...props}
    >
      <Button
        type="primary"
        onClick={handleClose}
        aria-label="Close"
        data-cy="close-modal-button"
        className={style['btn-close--modal-media']}
        icon={<div className={style['close-btn']}>
          <i className="fb-icon--close icons" />
        </div>}
      />
      <Content index={index} medias={medias} autoPlay onChange={onMediaPreviewedChange} />
    </Modal>
  );
};

export default MediaModal;
